export default function Footer() {
  return (
    <footer id="localizacao" className="bg-gradient-to-b from-black to-gray-900 border-t border-[#0047AB]/30 pt-16 pb-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/4829b03613a060f08ec5d40ad6d56bd7.png" 
              alt="Gamer Station Logo" 
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              A maior loja de games da Santa Ifigênia. Consoles, jogos e acessórios com os melhores preços de São Paulo.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://instagram.com/gamerstationsp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#0047AB]/20 rounded-lg flex items-center justify-center hover:bg-[#0047AB] transition-colors duration-300 cursor-pointer group"
              >
                <i className="ri-instagram-line text-xl text-[#0047AB] group-hover:text-white"></i>
              </a>
              <a 
                href="https://wa.me/5511951063038" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#0047AB]/20 rounded-lg flex items-center justify-center hover:bg-[#0047AB] transition-colors duration-300 cursor-pointer group"
              >
                <i className="ri-whatsapp-line text-xl text-[#0047AB] group-hover:text-white"></i>
              </a>
              <a 
                href="https://facebook.com/gamerstationsp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#0047AB]/20 rounded-lg flex items-center justify-center hover:bg-[#0047AB] transition-colors duration-300 cursor-pointer group"
              >
                <i className="ri-facebook-fill text-xl text-[#0047AB] group-hover:text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-4">Localização</h4>
            <div className="space-y-3 text-gray-400 text-sm">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#0047AB] text-xl flex-shrink-0 mt-0.5"></i>
                <p>
                  <strong className="text-white">Rua Aurora, 200</strong><br />
                  Lojas 103/105<br />
                  Santa Ifigênia, São Paulo - SP
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-[#0047AB] text-xl flex-shrink-0"></i>
                <a href="tel:+5511951063038" className="hover:text-[#0047AB] transition-colors duration-300">
                  (11) 95106-3038
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-lg mb-4">Horário de Funcionamento</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-[#0047AB] text-xl flex-shrink-0"></i>
                <div>
                  <p><strong className="text-white">Segunda a Sexta:</strong> 09h às 18h</p>
                  <p><strong className="text-white">Sábado:</strong> 09h às 15h</p>
                  <p><strong className="text-white">Domingo:</strong> Fechado</p>
                </div>
              </div>
            </div>
            <a 
              href="https://wa.me/5511951063038" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-6 inline-block bg-[#0047AB] text-white px-6 py-3 rounded-lg hover:bg-[#003380] transition-all duration-300 text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Fale Conosco
            </a>
          </div>
        </div>

        <div className="border-t border-[#0047AB]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-sm">
            <p>© 2026 Gamer Station. Todos os direitos reservados.</p>
            <p className="flex items-center gap-2">
              <i className="ri-instagram-line"></i>
              @gamerstationsp - 223 mil seguidores
            </p>
            <p>
              Desenvolvido por{' '}
              <a
                href="https://suritarafa.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0047AB] hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Suritarafa
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}